export const environment = {
  version: 'a3d60f7b4c9372714190722c5b831c755d02087b',
  buildDate: '202610230724',
  environment: 'feature-workflows',
  production: false,
  debug: true,
  dash0Enabled: true,
  baseUrl: 'https://develop.jobboard.catch-talents.dev',
  apiBaseUrl: 'https://feature-workflows.api.catch-talents.dev',
  apiBaseUrlFallback: 'https://develop.api.catch-talents.dev',
};
